import {
	IFirebaseService,
	IMarkerService,
} from "../interfaces/services.interfaces";
import AbstractService from "./abstract.service";
import { env } from "./../env";

export default class MarkerService
	extends AbstractService
	implements IMarkerService {
	constructor({ firebaseService }: { firebaseService: IFirebaseService }) {
		super({ firebaseService });
	}

	public async getMyData(): Promise<any> {
		const url = `${env.REACT_APP_SERVER_URL}/marker/my_data`;
		return await this.axiosInstance.get(url);
	}

	public async getImageUrl(
		image: string,
		download = false
	): Promise<{ data: string }> {
		const url = `${env.REACT_APP_SERVER_URL}/marker/getImageUrl`;
		return await this.axiosInstance.get(url, {
			params: download ? { image, download: 1 } : { image },
		});
	}
}
